import { TYPOGRAPHY } from "@store/theme/design";

export default {
    menuItemWeight: TYPOGRAPHY.weight.bold,
};
